module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Filter-86c6bd850237f9bb76ce7090dee574a9.svg";